var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { toJS } from "mobx";
export var ProblemBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var _a = store.newCreateRequestStore, progressStore = _a.progressStore, problemStore = _a.problemStore, questionsStore = _a.questionsStore, availabilityStore = _a.availabilityStore, homeStore = _a.homeStore, duplicateCheckStore = _a.duplicateCheckStore, recallCheckStore = _a.recallCheckStore, commonStore = _a.commonStore, shareStore = store.shareStore;
    var propsConnect = {
        currentUser: homeStore.currentUser,
        level: problemStore.level,
        clientId: commonStore.clientId,
        levelOneAliasList: problemStore.levelOneAliasList,
        levelTwoAliasList: problemStore.levelTwoAliasList,
        levelThreeAliasList: problemStore.levelThreeAliasList,
        levelOneId: problemStore.levelOneId,
        levelOneName: problemStore.levelOneName,
        levelOneTwoId: problemStore.levelTwoId,
        levelTwoName: problemStore.levelTwoName,
        levelThreeId: problemStore.levelThreeId,
        loading: problemStore.loading,
        problemCaseCadeName: toJS(problemStore.problemCaseCadeName),
        isAliasingView: problemStore.isAliasingView,
        duplicateEnvToggle: duplicateCheckStore.duplicateEnvToggle,
        lastLevel: problemStore.lastLevel,
        originWO: duplicateCheckStore.originWO,
        serviceCategoryId: problemStore.serviceCategoryId,
        duplicateWOList: duplicateCheckStore.duplicateWOList,
        screenWidth: duplicateCheckStore.screenWidth,
        screenLimit: duplicateCheckStore.screenLimit,
        serviceTypeId: problemStore.serviceTypeId,
        serviceCodeId: problemStore.serviceCodeId,
        duplicateWOsLoading: duplicateCheckStore.loading,
        videoTitle: problemStore.videoTitle,
        videoURL: problemStore.videoURL,
        howToVideoVisible: problemStore.howToVideoVisible,
        selectAlias: problemStore.selectAlias,
    };
    var dispatchConnect = {
        setProblemLevel: problemStore.setProblemLevel,
        initProblem: problemStore.initProblem,
        jump: progressStore.jump,
        getClientServiceComboAlias: problemStore.getClientServiceComboAlias,
        setProblemAlias: problemStore.setProblemAlias,
        backLevelQuestion: problemStore.backLevelQuestion,
        clearAfterStepData: function () {
            questionsStore.clearTroubleshootingAnswers();
            availabilityStore.clear();
        },
        clearCommonStoreKeepStatus: function () { commonStore.clear(); },
        setLevel: function (level) {
            problemStore.setProblemLevel(level);
            problemStore.backLevelQuestion(level);
        },
        reGetClientId: shareStore.reGetClientId,
        getDuplicateEnvToggle: duplicateCheckStore.getDuplicateEnvToggle,
        setLastLevel: problemStore.setLastLevel,
        duplicateUploadAttachment: duplicateCheckStore.uploadAttachment,
        duplicateDeleteAttachment: duplicateCheckStore.deleteAttachment,
        setOriginWO: duplicateCheckStore.setOriginWO,
        getDuplicateWOList: duplicateCheckStore.getDuplicateWOList,
        duplicateSubmit: duplicateCheckStore.submit,
        setScreenWidth: duplicateCheckStore.setScreenWidth,
        computeDuplicateWOList: duplicateCheckStore.computeDuplicateWOList,
        toggleWOAttachmentShow: duplicateCheckStore.toggleWOAttachmentShow,
        setDuplicateWOsLoading: duplicateCheckStore.setLoading,
        getServiceCodeWOType: problemStore.getServiceCodeWOType,
        getRecallWOList: recallCheckStore.getRecallWOList,
        setCommonDupCheck: function (isDupCheck) { return commonStore.setParam('isDupCheck', isDupCheck); },
        setHowToVideoVisible: problemStore.setHowToVideoVisible,
        howToVideoCreateCancelWO: problemStore.howToVideoCreateCancelWO,
        setSelectAlias: problemStore.setSelectAlias,
        setAvailabilityParam: function (key, value) { return availabilityStore.setParams(key, value); },
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
